import { useHistory } from "react-router";
import { useValue } from "../../../providers/ValueContext";
import CountUp from "react-countup";
import {
  ContainerHeader,
  ContainerTitle,
  TotalValue,
  HeaderImg,
  PlayngTime,
  TitleContent,
  BackButton,
  ContainerTools,
  ButtonContainerTools,
} from "./style";
import { useMemo } from "react";
import { useUser } from "../../../providers/UserContext";

const HeaderWeeklyReport = ({ selected }) => {
  const { entranceValue } = useValue();
  const { rodada, isNeededSetupIndustry } = useUser()

  const infosRound = useMemo(() => {
    // Definir as datas de início e fim
    const dataInicio = new Date(rodada?.rodadaInicio);
    const dataFim = new Date(rodada?.rodadaFinal);

    // Calcular a diferença em dias
    const diferenca = Math.ceil((dataFim - dataInicio) / 86400000) + 1;

    // Criar um objeto de data para a data atual
    const dataAtual = new Date().toISOString().substring(0, 10);

    // Calcular o número de dias decorridos
    const diasDecorridos = Math.ceil((new Date(dataAtual) - dataInicio) / 86400000) + 1;

    return {
      totalDias: diferenca,
      dia: diasDecorridos
    }
  }, [rodada])

  const history = useHistory();
  return (
    <ContainerHeader>
      <ContainerTitle>
        {entranceValue >= 0 ? (
          <TotalValue>
            <HeaderImg src="./images/cifrao_hidden_backgound.svg" />
            <CountUp
              end={entranceValue}
              separator="."
              decimal=","
              decimals={2}
              duration={0.5}
            />
          </TotalValue>
        ) : (
          <TotalValue>
            <HeaderImg src="./images/cifrao_hidden_backgound.svg" />
            <CountUp
              end={0}
              separator="."
              decimal=","
              decimals={2}
              duration={0.5}
            />
          </TotalValue>
        )}
        {/* <PlayngTime>
          {rodada ? (
            <>
              <div style={{ display: 'flex', paddingTop: 5 }}>
                <HeaderImg src="./images/icon_playng_game.svg" />
                <span>
                  Semana {rodada?.numero}
                </span>
              </div>
              <div style={{ display: 'flex' }}>
                <HeaderImg src="./images/icon-timer.svg" />
                <span>
                  Dia {infosRound?.dia} de {infosRound.totalDias}
                </span>
              </div>
            </>
          ) : (
            <div style={{ display: 'flex' }}>
              <HeaderImg src="./images/icon_playng_game.svg" />
              <span>
                Nenhuma rodada ativa
              </span>
            </div>
          )

          }
        </PlayngTime> */}
      </ContainerTitle>
      <TitleContent>
        <img src="./images/calendar.svg" alt="calendar" />
        <p>Relatório Semanal</p>
        <BackButton onClick={() => history.push(isNeededSetupIndustry ? "/home" : "/mapMenu")} />
      </TitleContent>
      <ContainerTools>
        <ButtonContainerTools
          onClick={() => history.push("/weeklyReportPcp")}
          className={selected[0]}
        >
          <img src="./images/pcp_button.svg" alt="pcp_button" />
        </ButtonContainerTools>
        <ButtonContainerTools
          onClick={() => history.push("/weeklyReportPurchase")}
          className={selected[1]}
        >
          <img src="./images/purchase_button.svg" alt="purchase_button" />
        </ButtonContainerTools>
        <ButtonContainerTools
          onClick={() => history.push("/weeklyReportProduction")}
          className={selected[2]}
        >
          <img src="./images/productions_1.svg" alt="production_button" />
        </ButtonContainerTools>
        <ButtonContainerTools
          onClick={() => history.push("/weeklyReportCommercial")}
          className={selected[3]}
        >
          <img src="./images/partnership.svg" alt="commercial_button" />
        </ButtonContainerTools>
      </ContainerTools>
    </ContainerHeader>
  );
};
export default HeaderWeeklyReport;
